/**
 * 存储订阅者（主题和处理器的）私有对象
 * ========================================================================
 * @type {{}}
 * @private
 */
const _subscribers = {}

export default _subscribers
